import application from './application/application.middleware';
import moduleMiddleware from './module/module.middleware';
import user from './user/user.middleware';

export default [
    application,
    moduleMiddleware,
    user
]